(function TripSummaryComponentTravelers($, Adzuki)
{
	'use strict';

	const component = {
		inject: [
			'getFaIconStyle',
		],
		emits: [
			'updateComponentTravelers',
		],
		props: {
			component: {
				type    : Object,
				required: true,
			},
			summaryTravelers: {
				type    : Array,
				required: true,
			},
		},
		template: '#ts-component-travelers',
		data() {
			return {
				mode             : 'view',
				travelers        : [],
				selectedTravelers: [],
			};
		},
		watch: {
			component: {
				handler() {
					this.travelers = this.component.travelers;
				},
				deep: true,
			},
		},
		computed: {
			travelerNames() {
				return this.travelers.map(traveler => traveler.name).join(', ');
			},
		},
		methods: {
			editTravelers() {
				// The edit pencil's tooltip is delegated from <body>, so swapping the
				// pencil out for the checkboxes would orphan it on screen. Hide it first.
				$('[data-toggle="tooltip"]').tooltip('hide');

				this.mode = 'update';
			},
			async updateTravelers() {
				const url = '/TripSummaries/updateComponentTravelers/' + this.component.fit_builder_component_id;

				try {
					let newTravelers = 'none';

					if (this.selectedTravelers.length > 0) {
						newTravelers = this.selectedTravelers;
					}

					const response = await Adzuki.Ajax.post(url, {
						travelers: newTravelers,
					});

					if (response.error) {
						return Adzuki.StatusMessage('error', `Error updating travelers: ${response.error}`);
					}

					// send event to update the travelers in the component
					const eventData = {
						fit_builder_component_id: this.component.fit_builder_component_id,
						travelers               : response.travelers,
					};

					this.mode = 'view';

					this.$emit('updateComponentTravelers', eventData);
				} catch (error) {
					return Adzuki.StatusMessage('error', `Error updating travelers: ${error}`);
				}
			},
		},
		mounted() {
			if (this.component.travelers) {
				this.travelers         = this.component.travelers;
				this.selectedTravelers = this.travelers.map(traveler => traveler.client_id);
			}
		},
	};

	Adzuki.VueComponents.TripSummaryComponentTravelers = component;
}(jQuery, window.Adzuki || {}));
